import Vue from 'vue'
import store from '~/store'
import router from '~/router'
import i18n from '~/plugins/i18n'
import App from '~/components/App'
import '~/plugins'
import '~/components'
import './fa.config'

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  i18n,
  store,
  router,
  ...App
})

(function ($) {
  $.fn.fixMe = function () {
    return this.each(function () {
      var $this = $(this),
        $t_fixed
      function init () {
        $this.wrap('<div class="container" />')
        $t_fixed = $this.clone()
        $t_fixed.find('tbody').remove().end().addClass('fixed').insertBefore($this)
        resizeFixed()
      }
      function resizeFixed () {
        $t_fixed.find('th').each(function (index) {
          $(this).css('width', $this.find('th').eq(index).outerWidth() + 'px')
        })
      }
      function scrollFixed () {
        var offset = $(this).scrollTop(),
          tableOffsetTop = $this.offset().top,
          tableOffsetBottom = tableOffsetTop + $this.height() - $this.find('thead').height()
        if (offset < tableOffsetTop || offset > tableOffsetBottom) { $t_fixed.hide() } else if (offset >= tableOffsetTop && offset <= tableOffsetBottom && $t_fixed.is(':hidden')) { $t_fixed.show() }
      }
      $(window).resize(resizeFixed)
      $(window).scroll(scrollFixed)
      init()
    })
  }
})(jQuery)

$(document).ready(function () {
  $('table').fixMe()
  $('.up').click(function () {
    $('html, body').animate({
      scrollTop: 0
    }, 2000)
  })
})



// WEBPACK FOOTER //
// ./resources/js/app.js